import * as cons from './constants';
import { requestReducerMaker, initialState } from '../helper'

export const getAllCourse = (state = initialState, action) => requestReducerMaker(cons.GET_ALL_COURSE, state, action);
export const getCourse = (state = initialState, action) => requestReducerMaker(cons.GET_COURSE, state, action);
